import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IWriteupsDetailState } from '..';

//
// Recucers
//
 

//
// WriteupsDetail Feature Selector
// will select this feature module's slice of the state
//
export const selectWriteupsDetail = createFeatureSelector<IWriteupsDetailState>(
  'WriteupsDetail'
);

//
// Writeup Detail CustomSchema Selector
//
export const selectWriteUpDetailLeftPanel = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailLeftPanel
);

export const selectWriteupDetailNavigateView = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.activeView
);

export const selectWriteupDetailRightPanel = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailRightPanel.activeView
);

export const getDealDetails = createSelector(
  selectWriteupsDetail,
  state => state?.writeupsDetailHeader?.dealDetail //added the safe navigation operators to let the tests pass. 
);

export const getCopiedTradeInsDealData = createSelector(
  selectWriteupsDetail,
  state => state?.writeupsDetailRightPanel?.dealDetail //added the safe navigation operators to let the tests pass. 
);

export const selectTradeDetailRightPanel = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailRightPanel.activeTrade
);

export const selectMessagePanel = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader
);

export const isMessageSent = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.isMessageSent
);
export const getMessages = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.messages
);
export const getProtectionProducts = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailLeftPanel.protectionProducts
);
export const getvspecurl = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.specUrlData
);
export const shareSMSSuccess = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.smsSuccessData
);

export const getCalculatedDataArrayPdf = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailPdf.dealDetail
);

export const getPPMonthlyPayment = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailLeftPanel.ppMonthlyPayment
);
// export const selectTaxesAndFees = createSelector(
//   selectWriteupsDetail,
//   state => state.writeupsDetailLeftPanel.taxesAndFees
// );
export const getRebates = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.incentiveId
)

export const getToyotaAccessories = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.toyotaAccessoriesServiceResponse
)
export const getDealerAccessories = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.dealerAccessoriesServiceResponse
)
export const getToyotaAccessoriesError = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.toyotaAccessoriesServiceError
)
export const getDealerAccessoriesError = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.dealerAccessoriesServiceError
)

//approvedOffer
export const getApprovedOffer = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.dealData.approvedOffer
)

export const getPPUpdatedData = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.ppUpdatedData
);

export const selectCustomerWriteupsSlidePanel = createSelector(
  selectWriteupsDetail,
  state => state.WriteupsDetailCustomerWriteups
);
export const getEmailTransactionSuccess = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.emailTransactionService
)
export const getSendTransactionServiceError = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.dealDetail.sendTransactionServiceError
)
export const getInventoryData = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.inventoryData
)
export const getAddress = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.addressData
)
export const getCustomers = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.customersData
)
export const getCustomersData = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.customersDataFull
)
export const plateTransferUIDetail = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.plateTransferUIDetails
)
export const addCoBuyer = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.addCobuyers
)
export const removeCoBuyer = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.removeCobuyers
)
export const getSeriesData = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.series
)
export const getVINDecodeData = createSelector(
  selectWriteupsDetail,
  state => state.writeupsDetailHeader.isVINDecodeData
)

